import { showDeleteConfirmation } from "components/Environment/edit/DeleteConfirmation";
import Box from "ds/components/Box";
import DropdownMenuEllipsis from "ds/components/DropdownMenu/Ellipsis";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import useTypedContext from "hooks/useTypedContext";
import { StackContext } from "views/Stack/Context";

import { showEnvVariableDrawer } from "../DrawerEnvVariable";
import { VariableCellComponentProps } from "./types";

const EnvVariableActionsCell = ({ variable, context }: VariableCellComponentProps) => {
  const {
    stack: { id: stackId },
  } = useTypedContext(StackContext);

  const canBeEdited = !(variable.runtime || context);

  return (
    <Box>
      <DropdownMenuEllipsis tooltip="Environment variable actions">
        {canBeEdited ? (
          <>
            <DropdownMenuItem
              onAction={() =>
                showEnvVariableDrawer({ id: variable.id, stackId, type: "STACK", variable })
              }
            >
              Edit variable
            </DropdownMenuItem>
            <DropdownMenuItem
              onAction={() => showDeleteConfirmation({ id: variable.id, stackId, type: "STACK" })}
              danger
            >
              Delete
            </DropdownMenuItem>
          </>
        ) : (
          <DropdownMenuItem
            onAction={() =>
              showEnvVariableDrawer({ id: variable.id, stackId, type: "STACK", variable })
            }
          >
            Override
          </DropdownMenuItem>
        )}
      </DropdownMenuEllipsis>
    </Box>
  );
};

export default EnvVariableActionsCell;
